/**
 * Enum of possible master source systems
 */
export type CustomerMasterSourceType = (typeof CustomerMasterSourceType)[keyof typeof CustomerMasterSourceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerMasterSourceType = {
  O2POP: 'O2POP',
  O2PRP: 'O2PRP',
  O2VOA: 'O2VOA',
  O2VOB: 'O2VOB',
  O2VOC: 'O2VOC',
  O2VOD: 'O2VOD',
  O2VOE01: 'O2VOE01',
  O2VOE02: 'O2VOE02',
  O2VOF: 'O2VOF',
  O2NON: 'O2NON',
  O2TVPRP: 'O2TVPRP',
} as const;
